import { Col, Container, Image, Row } from "react-bootstrap";
import BreadcrumbsItemList from "../breadcrumbs/breadcrumbs-item-list.component";
import PageTitle from "../page-title/page-title.component";
import SectionTitle from "../section-title/section-title.component";
import SectionBody from "../section-body/section-body.component";
import Footer from "../home-page-footer/home-page-footer.component";
import { useEffect } from "react";
import { APPLE_STORE_URL, GOOGLE_STORE_URL } from "../../utils/constants";
import about_us_logo from "../../assets/about-us-logo-2.png";
import about_us_logo_2 from "../../assets/about-us-logo-3.png";
import about_us_logo_3 from "../../assets/about-us-logo-4.png";
import about_us_logo_4 from "../../assets/about-us-logo-5.png";
import about_us_logo_5 from "../../assets/about-us-logo-6.png";

const AboutUsPage = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Container style={{ width: "99%", marginTop: "2%" }}>
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xl={10} lg={10} md={12} sm={12} xs={12}>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              // className="scrollable-product-column"
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <BreadcrumbsItemList
                  resetFilterSort={() => {}}
                  type={"About us"}
                />
                <PageTitle title={"About us"} />
              </div>
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ marginTop: "4%" }}
              >
                <SectionTitle title="Who we are" />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  marginTop: "32px",
                }}
              >
                <Row>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="text-column"
                  >
                    <SectionBody>
                      Welcome to Myooo, your trusted everyday platform for
                      household essentials, services, and more, all in one
                      place.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      We proudly serve communities by making everyday living
                      more accessible and affordable. From exclusive deals to
                      practical tools and tailored experiences, we’re on a
                      mission to help households get more value from the things
                      they already do — shop, share, explore, and connect.
                    </SectionBody>
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={0} xs={0}></Col>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="image-column"
                  >
                    <Image
                      src={process.env.PUBLIC_URL + about_us_logo}
                      alt="Logo"
                      // className="logo-image"
                      style={{ objectFit: "contain", width: "70%" }}
                    />
                  </Col>
                </Row>
              </Col>
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ marginTop: "4%" }}
              >
                <SectionTitle title="What we offer" />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  marginTop: "32px",
                }}
              >
                <Row>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="image-column"
                  >
                    <Image
                      src={process.env.PUBLIC_URL + about_us_logo_2}
                      alt="Logo"
                      // className="logo-image"
                      style={{ objectFit: "contain", width: "100%" }}
                    />
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={0} xs={0}></Col>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="text-column"
                  >
                    <SectionBody>
                      Our platform brings together a wide range of categories
                      including home, leisure, pet, dining, travel, wellness,
                      and more with exclusive discounts and diverse offerings
                      designed not only to ease expenses but also to enrich
                      daily life, simplify routines, and support the interests
                      and needs of every household member.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      We also connect you with service providers offering
                      cleaning, delivery, personal care, and expert
                      consultations to support your lifestyle.
                    </SectionBody>
                  </Col>
                </Row>
              </Col>
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ marginTop: "4%" }}
              >
                <SectionTitle title="The app" />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  marginTop: "32px",
                }}
              >
                <Row>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="text-column"
                  >
                    <SectionBody>
                      Through our app, you can tap into an active community of
                      householders and lifestyle seekers.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      Share tips, explore trusted recommendations, connect with
                      others, or even offer your own products and services.
                    </SectionBody>
                    <div
                      style={{
                        marginTop: "5%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <a
                        href={GOOGLE_STORE_URL}
                        style={{ marginRight: "3%" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src="./images/Badge.png" alt="" />
                      </a>
                      <a
                        href={APPLE_STORE_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src="./images/Frame 11.png" alt="" />
                      </a>
                    </div>
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={0} xs={0}></Col>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="image-column"
                  >
                    <Image
                      src={process.env.PUBLIC_URL + about_us_logo_3}
                      alt="Logo"
                      // className="logo-image"
                      style={{ objectFit: "contain", width: "100%" }}
                    />
                  </Col>
                </Row>
              </Col>
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ marginTop: "4%" }}
              >
                <SectionTitle title="Community & Connection" />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  marginTop: "32px",
                }}
              >
                <Row>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="image-column"
                  >
                    <Image
                      src={process.env.PUBLIC_URL + about_us_logo_4}
                      alt="Logo"
                      // className="logo-image"
                      style={{ objectFit: "contain", width: "100%" }}
                    />
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={0} xs={0}></Col>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="text-column"
                  >
                    <SectionBody>
                      Our platform brings people together through built-in
                      social features. Users can share posts and videos, chat
                      with others, follow topics of interest, and join
                      communities built around everyday life.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      Whether you're exchanging tips, staying inspired, or
                      sharing personal moments, there's space for you.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      You can also build your voice as a creator, become part of
                      the platform’s growing social community and earn money
                      through our app.
                    </SectionBody>
                  </Col>
                </Row>
              </Col>
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ marginTop: "4%" }}
              >
                <SectionTitle title="Get in touch" />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  marginTop: "32px",
                }}
              >
                <Row>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="text-column"
                  >
                    <SectionBody>
                      At Myooo, we’re here to help you make the most out of your
                      time, budget, and lifestyle. Whether you're exploring new
                      services or household essentials, we’re ready to support
                      your goals.
                    </SectionBody>
                    <SectionBody style={{ marginTop: "5%" }}>
                      Join us today and discover the many ways we can support
                      you and your pet, send us an email at{" "}
                      <SectionBody style={{ textDecoration: "underline" }}>
                        my@greggii.com
                      </SectionBody>{" "}
                      or give us a call at 1-786-877-6205.
                    </SectionBody>
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={0} xs={0}></Col>
                  <Col
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="image-column"
                  >
                    <Image
                      src={process.env.PUBLIC_URL + about_us_logo_5}
                      alt="Logo"
                      // className="logo-image"
                      style={{ objectFit: "contain", width: "100%" }}
                    />
                  </Col>
                </Row>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default AboutUsPage;
